import { Dialog } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const StyledDialog = styled(Dialog)({
  width: "600px",
  height: "80vh",
  maxHeight: "800px",
})

export const DialogBody = styled.div({
  height: "calc(100% - 100px)",
  padding: "0 !important",
  overflow: "scroll",
})

export const FooterContainer = styled(FlexContainer)({
  justifyContent: "flex-end",
  gap: "10px",
  padding: "10px",
})
